<template>
  <div class="agreement-container">
    <div class="agreement-content" v-html="policyText"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      policyText:
	  `
	  麦小通隐私政策
	  杭州麦田熊科技有限公司（以下称“我们”）非常重视用户的个人信息保护，本隐私政策旨在向您说明，在您使用麦小通App及相关服务时，我们如何收集、存储、使用、共享、保护您的个人信息，以及您所享有的各项权利。
	  在使用麦小通服务前，请您仔细完整阅读本隐私政策。如您不同意本隐私政策任何部分，请停止使用麦小通全部服务。您登录、使用麦小通服务，即表示您已充分阅读、理解并同意本隐私政策全部内容。
	  1. 定义
	  1.1 个人信息：指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。
	  1.2 敏感个人信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇的个人信息。
	  1.3 用户：指使用麦小通供应链订货服务的线下门店经营者、门店授权操作人员。
	  1.4 麦小通App：指杭州麦田熊科技有限公司运营的麦小通App。
	  2. 我们如何收集您的个人信息
	  2.1 账号与门店信息
	  为完成商户准入、开通账号，我们会收集门店名称、门店地址、联系人姓名、联系手机号码，用于账号开通、身份核验、业务通知、订货履约。该类信息为开展B端订货业务的必要信息，若不提供则无法使用平台服务。
	  2.2 业务订单信息
	  在您下单订货、提交报损、调货、对账时，我们收集订单内容、收货信息、单据内容、支付记录，用于完成订货履约、售后处理、财务对账。
	  2.3 设备与日志信息
	  为保障系统安全、排查故障风险，我们会收集设备型号、操作系统、网络类型、登录时间、操作日志、异常崩溃日志、设备标识符（IMEI）、软件安装列表。IMEI设备标识符用于账号风控识别、异常设备登录判定、防范盗号与欺诈风险，仅用于安全风控，不会用于用户画像、营销推送。软件安装列表仅用于安全风控，识别设备风险环境、恶意软件，防范账号被盗、欺诈作弊风险，不会读取、上传具体应用内容，不会用于广告、用户画像。该类信息用于风控防护、产品问题排查优化。
	  2.4 客服沟通信息
	  当您联系客服反馈问题，我们会保存您反馈的文字、图片、联系方式，用于处理您的咨询、投诉、售后问题。
	  2.5 非必要权限说明
	  本平台不会主动申请通讯录、相册、定位、麦克风、相机等敏感权限；如您上传图片凭证，仅在您主动选择时才访问相册/相机，权限由用户自主授权，拒绝权限不影响核心订货业务使用。
	  2.6 您可以拒绝提供非必要信息，但拒绝提供必要信息，将导致无法正常使用麦小通服务。
	  3. 我们如何使用您的个人信息
	  3.1 用于提供、维护、保障订货业务服务；完成订单处理、货品配送、报损调货、售后客服、对账结算。
	  3.2 用于产品优化、功能迭代，统计分析服务使用情况，改善用户体验。
	  3.3 用于账号安全防护，识别异常登录、刷单、违规操作，防范欺诈与风险行为。
	  3.4 用于向您推送业务通知、订单状态、售后提醒；经您许可后推送营销活动优惠券信息，您可随时关闭营销推送。
	  3.5 遵守法律法规、监管部门要求，配合司法机关、行政机关依法调取相关信息。
	  3.6 我们不会将收集到的个人信息用于本政策未载明的其它用途。若发生用途变更，我们会再次向您告知并征得同意。
	  4. 信息存储与保存期限
	  4.1 您的全部数据均存储于中华人民共和国境内合规服务器，不会进行个人信息出境。
	  4.2 我们仅在实现本政策所述目的所必需的最短期限内保存您的信息。
	  4.3 账号注销后，我们会对您的非必要个人信息做删除或匿名化处理。但依据《电子商务法》《税收征收管理法》等法律要求，已经生成的订单、交易、对账凭证，我们需要按照法定留存期限予以归档保存，该部分数据不会随账号注销删除。
	  4.4 系统会存在定期备份，备份数据会按照安全策略定期清理。
	  5. 信息共享、转让、公开披露
	  5.1 原则上我们不会向无关第三方共享、转让您的个人信息。
	  5.2 业务履约必要的共享：为完成订货配送履约，会向合作仓库、物流服务商提供必要收货门店地址、联系人、联系电话、订单内容。合作第三方仅可用于完成本次配送业务，禁止挪作他用。我们会和合作方签署数据保密协议。
	  5.3 支付相关：当您使用第三方支付，相关支付信息由支付机构处理，我们按照支付机构隐私规则执行。
	  5.4 云技术服务商：我们使用合规云服务商提供存储、计算技术支持，云服务商仅做技术处理，无权把您的个人信息用于其他商业目的。
	  5.5 以下情形，我们可以对外提供信息，无需您的同意：
	  （1）根据法律法规、司法机关、行政机关出具的生效法律文书；
	  （2）为维护国家安全、公共安全、重大公共利益；
	  （3）为保护我们、用户、第三人的人身财产重大合法权益。
	  5.6 不会公开披露您的个人信息，除非获得您明确同意或者法律强制要求。
	  6. 本地缓存数据
	  6.1 在App运行过程中，我们会在您设备本地存储少量缓存数据，用于保存登录状态、简单业务配置，避免您重复登录，提升使用体验。
	  6.2 本地缓存仅保存在您当前使用的设备上，不会用于跟踪采集您其他无关行为。清除App缓存会清空该部分本地数据。
	  7. 用户的个人信息相关权利
	  7.1 查询权：您可以在账号设置页面查看您的门店信息、订单、业务记录。
	  7.2 更正权：如果您发现我们保存的门店、联系人信息有误，您可以在设置中修改更正。
	  7.3 删除权：在符合法律条件下，您可以申请删除个人信息。法定需要留存的交易凭证除外。
	  7.4 注销账号权：您可通过本政策第11条的客服联系方式提交账号注销申请，我们将按法定流程审核处理。
	  7.5 撤回授权：对于非必要权限，您可以随时在手机系统设置撤回授权。撤回授权不影响此前基于授权开展的业务效力。
	  7.6 如您需要行使上述查询、更正、删除、注销等权利，均可以通过客服联系方式提交申请，我们会在法律规定的15个工作日内进行核实处理。
	  8. 未成年人保护
	  8.1 麦小通为面向B端商户的订货工具，服务对象为成年门店经营者与授权工作人员，我们不面向未成年人提供服务。
	  8.2 如果我们意外收集到未成年人个人信息，一经发现会尽快做删除处理。
	  9. 隐私政策的变更
	  9.1 我们有权根据法律法规更新、业务迭代修订本隐私政策。
	  9.2 一般性修改，将通过客户端公告进行公示。涉及重大变更，我们将以弹窗提示等显著方式告知您，需要您重新确认同意。
	  9.3 如果您在政策更新生效之后继续使用麦小通服务，则视为接受更新后的隐私政策；如不同意，请停止使用服务。
	  10. 安全防护措施
	  10.1 我们采用加密传输、权限隔离、访问控制、日志审计等安全技术措施，保护您的数据安全。
	  10.2 但请注意，互联网技术无法做到绝对安全，如果发生个人信息安全事件，我们将按照法律法规要求及时告知用户与监管机构。
	  生效日期：2026年08月31日
	  更新日期：2026年08月31日
	  11. 联系我们
	  如您对于本隐私政策有疑问、建议、投诉，可通过如下方式联系我们：
	  主体名称：杭州麦田熊科技有限公司
	  联系电话：19244029917
	  联系地址：浙江省杭州市萧山区宁围街道民和路481号联合中心南区1幢1702室
	  如您对于个人信息处理问题反馈、账号注销申请，我们一般将在十五个工作日内予以回复处理。
	  12. 其他
	  12.1 本隐私政策受中华人民共和国法律管辖。
	  12.2 本隐私政策部分条款被认定无效，不影响其余条款继续有效。
	  12.3 测试账号说明：本应用为B端商户订货系统，如需完整功能测试，可联系客服获取测试账号，测试账号可体验App全部业务功能。
	  `
,
    };
  },
  methods: {},
};
</script>
<style scoped>
.agreement-container {
  padding: 20px;
  line-height: 1.6;
  font-size: 14px;
  color: #333;
}
.agreement-content {
  white-space: pre-wrap;
}
</style>
